import type { ReactNode } from 'react';

import { Heading } from '@/hen-ui/atomics/Heading';
import { Icon } from '@/hen-ui/atomics/Icon';
import { COMPONENT_IDS } from '@/hen-ui/catalog/component-ids';
import { Card } from '@/hen-ui/composites/Card';
import { Flex } from '@/hen-ui/composites/Flex';

interface CareerExplorerRecommendationsShellProps {
  title: string;
  children: ReactNode;
}

export const CareerExplorerRecommendationsShell = ({
  children,
  title,
}: CareerExplorerRecommendationsShellProps) => (
  <Card
    variant='background-transparent'
    border='none'
    padding='none'
    rounded='lg'
    data-hen-id={COMPONENT_IDS.CareerExplorerRecommendations}
    className='w-full overflow-hidden'
  >
    <Flex
      direction='row'
      gap='xs'
      align='center'
      width='full'
      data-slot='recommendations-header'
      className='rounded-t-lg bg-secondary-700 p-md'
    >
      <Icon
        icon='sparkles'
        size='md'
        color='white'
        strokeWidth={1.5}
        aria-hidden
      />
      <Heading variant='h4' tag='h3' color='white'>
        {title}
      </Heading>
    </Flex>

    <Flex
      direction='column'
      gap='md'
      width='full'
      className='rounded-b-lg border border-t-0 border-neutral-200 bg-neutral-100 p-md'
    >
      {children}
    </Flex>
  </Card>
);
